<template>
  <div
    class="faq-item"
    :data-question="item.question"
  >
    <div
      :id="`faq-button-${item.slug}`"
      class="faq-item__button"
      :class="{ 'is-open': isOpen }"
      :aria-expanded="isOpen"
      :aria-controls="`faq-panel-${item.slug}`"
      @click="toggle"
    >
      <span class="faq-item__question">{{ item.question }}</span>

      <div class="faq-item__icon">
        <MinusIcon v-if="isOpen" />
        <PlusIcon v-else />
      </div>
    </div>

    <transition
      name="accordion"
      @enter="onEnter"
      @after-enter="onAfterEnter"
      @leave="onLeave"
      @after-leave="onAfterLeave"
    >
      <div
        v-show="isOpen"
        :id="`faq-panel-${item.slug}`"
        class="faq-item__content"
      >
        <p
          class="faq-item__answer"
          v-html="item.answer"
        />
      </div>
    </transition>
  </div>
</template>

<script setup>
import MinusIcon from '~/components/Common/Svg/MinusIcon.vue';
import PlusIcon from '~/components/Common/Svg/PlusIcon.vue';

defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const isOpen = ref(false);

const toggle = () => {
  isOpen.value = !isOpen.value;
};

const onEnter = (el) => {
  el.style.height = '0px';
  el.style.opacity = '0';
  requestAnimationFrame(() => {
    el.style.transition = 'height 200ms ease, opacity 200ms ease';
    el.style.height = `${el.scrollHeight}px`;
    el.style.opacity = '1';
  });
};
const onAfterEnter = (el) => {
  el.style.height = 'auto';
  el.style.transition = '';
};
const onLeave = (el) => {
  el.style.height = `${el.scrollHeight}px`;
  el.style.opacity = '1';
  requestAnimationFrame(() => {
    el.style.transition = 'height 200ms ease, opacity 200ms ease';
    el.style.height = '0px';
    el.style.opacity = '0';
  });
};
const onAfterLeave = (el) => {
  el.style.transition = '';
};
</script>

<style scoped lang="scss">
@import './FaqItem';
</style>
